import { useEffect, useRef } from 'react';
import styled from 'styled-components';
import { Formik, Field, FormikProps } from 'formik';
import { object, string } from 'yup';
import { useLocation } from 'react-router-dom';
import { REQUIRED, EMAIL_FORMAT } from '../shared/FormConstants';
import Button from '../shared/Button';
import TextInput from '../shared/TextInput';
import { Form } from '../shared/styled/Form';

export const FormActions = styled.div`
  button {
    margin-top: 1rem;
    width: 100%;
  }
`;

type Props = {
  onSubmit: ({
    emailAddress,
    referenceNumber,
  }: {
    emailAddress: string;
    referenceNumber: string;
  }) => Promise<any>;
};

const OrderForm = ({ onSubmit }: Props) => {
  const location = useLocation();

  const formRef = useRef<FormikProps<any>>(null);

  const searchParams = new URLSearchParams(location?.search);
  const emailParam = searchParams.get('email');
  const orderRefParam = searchParams.get('orderReference');

  useEffect(() => {
    if (
      emailParam &&
      orderRefParam &&
      formRef.current &&
      formRef.current.isValid
    ) {
      formRef.current.handleSubmit();
    }
  }, []);

  return (
    <Formik
      initialValues={{
        emailAddress: emailParam || '',
        referenceNumber: orderRefParam || '',
      }}
      validationSchema={object().shape({
        emailAddress: string().email(EMAIL_FORMAT).required(REQUIRED),
        referenceNumber: string().required(REQUIRED),
      })}
      onSubmit={async (payload, { setSubmitting }) => {
        setSubmitting(true);
        const result = await onSubmit(payload);
        if (!result) {
          setSubmitting(false);
        }
      }}
      innerRef={formRef}
    >
      {({ handleSubmit, isSubmitting }) => (
        <Form onSubmit={handleSubmit} className="form-login">
          <Field
            component={TextInput}
            type="email"
            label="Email address"
            name="emailAddress"
            required
          />
          <Field
            component={TextInput}
            label="Order reference"
            name="referenceNumber"
            tip="Your order reference of the original purchase"
            required
          />
          <FormActions>
            <Button
              id="submit"
              type="submit"
              disabled={isSubmitting}
              loading={isSubmitting}
            >
              Start new return
            </Button>
          </FormActions>
        </Form>
      )}
    </Formik>
  );
};

export default OrderForm;
